module.exports = __webpack_public_path__ + "img/chidao.03fa5b1b.png";